import Name from './Name';
import BirthDate from './Birthdate';
import Mail from './Mail';
import MobileWrap from './mobile/index';

export { Name, BirthDate, Mail, MobileWrap };
